import { Pipe, PipeTransform } from '@angular/core';
import {EventInterface} from '@app/03-modules/events/interfaces/event.interface';

@Pipe({ name: 'eventStatus' })
export class EventStatusPipe implements PipeTransform {
  constructor(
  ) {}
  transform(event: EventInterface): string {
    if (event.finishedAt) {
      return 'Hotovo';
    }
    if (event.startedAt && !event.finishedAt) {
      if (event.media.isPaused) {
        return 'Pozastaveno';
      } else {
        return 'Probíhá';
      }
    }
    return 'Připraveno';
  }
}
